import { useAuthStoreUser, UserAuthStore } from "@/stores/app/authUser";
import { computed, ref } from "vue";

export function cHasAiIntegration(authStore?: UserAuthStore) {
    if (!authStore) authStore = useAuthStoreUser();
    
    const __debugForceHasAiIntegration = ref(false);

    // Só mostra o switch de Agente IA se algum inbox da conta atual tem integração de IA vinculada
    const hasAiIntegration = computed(() =>
        __debugForceHasAiIntegration.value ||
        authStore.currentAccountInboxes.some(i => !!i.idInstanciaBotIa || !!i.idAgenteBotIa)
    );

    return {
        __debugForceHasAiIntegration,
        hasAiIntegration
    }
}